import React from "react";
import { useAppSelector } from "../../../../../util/store-types";
import RtrPill from "components/design-system/rtr-pill";
import Close from "images/design-system-svgs/close.svg";
import { getRentalDateAnnotation } from "helpers/grid-top-filters-helpers";

type RentalDatePillProps = {
  onClearDates: () => void;
  onClick: () => void;
};

const RentalDatePill = ({ onClearDates, onClick }: RentalDatePillProps) => {
  const { date, duration = "4" } = useAppSelector(state => state.workingFilters);

  const onClickClear = (e: MouseEvent) => {
    e.stopPropagation();
    onClearDates();
  };

  return (
    <RtrPill
      onClick={onClick}
      text={getRentalDateAnnotation(date, duration)}
      className="bg-offWhite underline font-normal">
      <Close onClick={onClickClear} data-test-id="clear-dates" className="ml-1.5" />
    </RtrPill>
  );
};

export default RentalDatePill;
